import React from 'react';
import eq1 from '../Images/eq1.jpg'

const MidPage = () => {
  return (
    <>
    <div className='container-md'>
    <img src={eq1} className="img-thumbnail image-fluid"  alt="..."/> 
    <div className="card-body">
    <h5 className="card-title">workout sweat repeat</h5>
    <p className="card-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
    <a href="#" className="btn btn-primary">Go somewhere</a>
  </div>
    </div> 
   
  </>
  )
}

export default MidPage;